import React, { SetStateAction } from 'react';
import { Button, Form, Row } from 'react-bootstrap';
import { Company } from '../../../model/company/Company';
import AutocompleteSelect from '../../../shared/components/AutocompleteSelect';
import _ from 'lodash';
import { Campaign } from '../../../model/campaign/Campaign';
import CardLayout from '../../../shared/components/CardLayout';
import SingleSelectDropdown from '../../../shared/components/SingleSelectDropdown';

interface IProps {
    company: Company[];
    campaign: Campaign[];
    pagination: any;
    setPagination: React.Dispatch<SetStateAction<any>>;
}

const OnboardingFilters = ({ company, campaign, setPagination, pagination }: IProps) => {
    const handleChange = _.debounce(event => {
        const { name, value } = event.target;
        setPagination((prev: any) => ({ ...prev, [name]: value, page: 1 }));
    }, 300);

    const renderSelect = (name: string, placeholder: string, trueLabel: string, falseLabel: string) => {
        const current = String(pagination[name]);
        return (
            <SingleSelectDropdown
                placeholder={placeholder}
                options={[
                    { value: 'true', label: trueLabel },
                    { value: 'false', label: falseLabel },
                ]}
                selected={current === 'true' || current === 'false' ? current : ''}
                onChange={value => setPagination((prev: any) => ({ ...prev, [name]: value || 'null', page: 1 }))}
            />
        );
    };

    return (
        <CardLayout classCard="mb-5" classBody="p-4">
            <Row>
                <div className="form-group col-md col-sm-12">
                    <AutocompleteSelect
                        className="autocomplete-input"
                        list={company}
                        listKey={'displayName'}
                        updateState={id => setPagination((prev: any) => ({ ...prev, companyId: id }))}
                        placeholder={'Company'}
                    />
                </div>
                <div className="form-group col-md col-sm-12">
                    <AutocompleteSelect
                        className="autocomplete-input"
                        list={campaign}
                        listKey={'displayName'}
                        updateState={id => setPagination((prev: any) => ({ ...prev, campaignId: id }))}
                        placeholder={'Campaign'}
                    />
                </div>
                <div className="form-group col-md col-sm-12">
                    <Form.Control name="handle" type="text" placeholder="Type handle...." onChange={handleChange} />
                </div>
                <div className="col-md-2 col-6">
                    {renderSelect('isContacted', 'is Contacted?', 'Contacted', 'NotContacted')}
                </div>
                <div className="col-md-2 col-6">
                    {renderSelect('isOnboarded', 'is Onboarded?', 'Onboarded', 'Not Onboarded')}
                </div>
                <div className="col-md-2 col-6">
                    {renderSelect('isDeclined', 'Onboarding Declined?', 'Declined', 'Not Declined')}
                </div>
            </Row>
            <Button
                className="mt-4"
                onClick={() => setPagination((prev: any) => ({ ...prev, trigger: !prev.trigger }))}
            >
                Search
            </Button>
        </CardLayout>
    );
};

export default OnboardingFilters;
